import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-white text-primary mt-12 sm:mt-20 border-t border-gray-200">
      <div className="container-custom py-6 sm:py-8 md:py-12">
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 md:gap-8">
          {/* Logo et marque */}
          <div className="col-span-2 sm:col-span-1">
            <h3 className="font-playfair text-base sm:text-xl font-bold mb-2 sm:mb-4 text-primary">
              Aqua<span className="text-secondary">HomeDelivery</span>
            </h3>
            <p className="text-gray-600 text-xs sm:text-sm">
              Toutes les boissons livrées chez vous en moins de 24 h.
            </p>
            <p className="text-gray-400 text-[10px] sm:text-xs mt-2 sm:mt-4">
              © 2026 AquaHomeDelivery<br />Tous droits réservés
            </p>
          </div>
          
          {/* Navigation */}
          <div>
            <h4 className="font-bold text-sm sm:text-base mb-2 sm:mb-4 text-primary">Navigation</h4>
            <ul className="space-y-1 sm:space-y-2 text-xs sm:text-sm text-gray-600">
              <li><Link to="/" className="hover:text-secondary transition">Accueil</Link></li>
              <li><Link to="/how-it-works" className="hover:text-secondary transition">Livraison</Link></li>
              <li><Link to="/products" className="hover:text-secondary transition">Boutique</Link></li>
              <li><Link to="/faq" className="hover:text-secondary transition">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-secondary transition">Contact</Link></li>
            </ul>
          </div>
          
          {/* Aide */}
          <div>
            <h4 className="font-bold text-sm sm:text-base mb-2 sm:mb-4 text-primary">Aide</h4>
            <ul className="space-y-1 sm:space-y-2 text-xs sm:text-sm text-gray-600">
              <li><Link to="/account" className="hover:text-secondary transition">Mon compte</Link></li>
              <li><Link to="/cart" className="hover:text-secondary transition">Mon panier</Link></li>
              <li><Link to="/how-it-works" className="hover:text-secondary transition">Livraison</Link></li>
            </ul>
          </div>
          
          {/* Informations légales */}
          <div className="col-span-2 sm:col-span-1">
            <h4 className="font-bold text-sm sm:text-base mb-2 sm:mb-4 text-primary">Informations légales</h4>
            <ul className="space-y-1 sm:space-y-2 text-xs sm:text-sm text-gray-600">
              <li><Link to="/legal/cgv" className="hover:text-secondary transition">CGV</Link></li>
              <li><Link to="/legal/returns" className="hover:text-secondary transition">Remboursements</Link></li>
              <li><Link to="/legal/privacy" className="hover:text-secondary transition">Confidentialité</Link></li>
              <li><Link to="/legal/cookies" className="hover:text-secondary transition">Cookies</Link></li>
              <li><Link to="/legal/mentions" className="hover:text-secondary transition">Mentions légales</Link></li>
            </ul>
          </div>
        </div>
        
        {/* Bas de page */}
        <div className="border-t border-gray-200 mt-4 sm:mt-6 md:mt-8 pt-4 sm:pt-6 md:pt-8 text-center text-[10px] sm:text-sm text-gray-400">
          <p>AquaHomeDelivery - Livraison de packs d'eau, boissons et produits laitiers à domicile</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;